import { Divider, Stack, TextField } from 'braid-design-system';
import { useState } from 'react';
import { InlineCode } from 'scoobie';

import { useEnvironmentConfig } from '#src/hooks/environment.tsx';
import { SectionHeadingLink } from '../SectionHeadingLink/SectionHeadingLink.tsx';
import { AdPerformancePanel } from './components/AdPerformancePanel.tsx';

export const AdPerformanceSection = () => {
  const [positionProfileId, setPositionProfileId] = useState<string>('');
  const { seekAnzSchemeId } = useEnvironmentConfig();

  return (
    <Stack space="large">
      <SectionHeadingLink href="/use-cases/ad-performance">
        Ad Performance Panel
      </SectionHeadingLink>

      <Stack space="large">
        <TextField
          id="positionProfileId"
          label="Position Profile OID"
          message={
            <>
              e.g.{' '}
              <InlineCode>
                {seekAnzSchemeId}:positionProfile:jobAd:24FXNXVwM
              </InlineCode>
            </>
          }
          onClear={() => setPositionProfileId('')}
          value={positionProfileId}
          onChange={(event) => setPositionProfileId(event.currentTarget.value)}
        />

        {positionProfileId ? (
          <>
            <Divider />
            <AdPerformancePanel positionProfileId={positionProfileId} />
          </>
        ) : null}
      </Stack>
    </Stack>
  );
};
